import { z } from "zod";
import { useEffect } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel, FormMessage,
} from "../shared/form";
import {Input} from "~/react/components/shared/input";
import clsx from "clsx";

export function InviteFriendForm({
                                   submitHandler,
                                   data,
                                   isFormSubmitting,
                                   setIsFormSubmitting,
                                   serverErrors,
                                   setServerErrors,
                                         }) {
  const formFields = [...data?.fields];
  const formSchema = z.object({
    ...formFields.reduce((acc, field) => {
      if (field.fieldType === "hidden") {
        acc[field.fieldName] = z.any();
      }
      if (field.fieldType === "email") {
        const maxLength = field.fieldValidation.find(
          (validation) => validation.validationType === "maxLegnth"
        );
        const required = field.fieldValidation.find(
          (validation) => validation.validationType === "required"
        );
        acc[field.fieldName] = z
          .string({ message: required?.message })
          .min(1, {
            message: required?.message,
          })
          .max(maxLength?.validationValue ?? 255, {
            message: maxLength?.message,
          })
          .email({ message: "Please enter a valid email address" });
      }
      return acc;
    }, {}),
  });
  const defaultFormValues = formFields.reduce((acc, field) => {
    acc[field.fieldName] = field.fieldValue;
    return acc;
  }, {});
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      ...defaultFormValues,
    },
  });
  const submitFormHandler = (body) => {
    submitHandler(body);
  };
  useEffect(() => {
    if (isFormSubmitting) {
      setIsFormSubmitting(false);
      form.handleSubmit(submitFormHandler)();
    }
  }, [isFormSubmitting]);

  return (
    <div>
      <Form {...form}>
        <form>
          {formFields.map((formField) => {
            if (formField.fieldType === "hidden" && !!formField.fieldValue) {
              return (
                <FormField
                  key={formField.fieldName}
                  control={form.control}
                  name={formField.fieldName}
                  render={({ field }) => (
                    <FormItem style={{ visibility: "hidden" }}>
                      <FormLabel>{formField.fieldLabel}</FormLabel>
                      <FormControl>
                        <input
                          type="hidden"
                          style={{ visibility: "hidden" }}
                          {...field}
                        />
                      </FormControl>
                    </FormItem>
                  )}
                />
              );
            }

            if (formField.fieldType === "email") {
              return (
                <FormField
                  key={formField.fieldName}
                  control={form.control}
                  name={formField.fieldName}
                  render={({ field, fieldState }) => (
                    <FormItem className="shadcn-input-wrapper shadcn-input-wrapper--mt-24">
                      <FormLabel className="shadcn-input-label">
                        {formField.fieldLabel}
                      </FormLabel>
                      <FormControl>
                        <Input
                          className={clsx(
                            "shadcn-input",
                            fieldState?.error && "shadcn-invalid"
                          )}
                          type="email"
                          {...field}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            setServerErrors({});
                          }}
                        />
                      </FormControl>
                      <FormMessage className="shadcn-input-error-message shadcn-input-error-message--pl-30">
                        {fieldState?.error?.message}
                        {Array.isArray(serverErrors?.[formField.fieldName])
                          ? serverErrors?.[formField.fieldName]?.join(" ")
                          : serverErrors?.[formField.fieldName]}
                      </FormMessage>
                    </FormItem>
                  )}
                />
              );
            }

            return <></>;
          })}
        </form>
      </Form>
    </div>
  );
}
